import { createContext, useContext } from "react";
import type { ConfirmDialogContextValue } from "./types";

export const ConfirmDialogContext =
  createContext<ConfirmDialogContextValue | null>(null);

export function useConfirmDialogContext() {
  const ctx = useContext(ConfirmDialogContext);
  if (!ctx) {
    throw new Error(
      "ConfirmDialog sub-components must be used within <ConfirmDialog>",
    );
  }
  return ctx;
}
